<template>
  <div>
    <!--group with sub-items-->
    <v-list-group
      v-if="item.items"
      ref="listGroup"
      active-class="blue-grey--text"
      no-action
    >
      <v-list-item :id="`AppDrawerChildMenuGroup${item.name}`" slot="activator">
        <v-list-item-action v-if="item.icon">
          <v-icon>
            {{ generateIcons(item.icon) }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $helpers.translateKeyContent("FalconSidebarMenu", item.text) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- sub-item -->
      <template v-for="(subItem, key2) in item.items">
        <!--child item-->
        <app-drawer-child
          v-if="subItem.items && subItem.items.length"
          :key="key2"
          :item="subItem"
          class="nested-sidebar"
        />

        <v-list-item
          v-else
          :id="`AppDrawerChildMenuChild${subItem.name}`"
          :key="key2"
          :to="generateLink(item, subItem)"
          :href="subItem.href"
          :disabled="subItem.disabled"
          :target="subItem.target"
          nuxt
          active-class=""
          exact-active-class="blue-grey--text text--darken-3 blue-grey lighten-3"
        >
          <v-list-item-action v-if="subItem.icon">
            <v-icon>
              {{ generateIcons(subItem.icon) }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{
                $helpers.translateKeyContent("FalconSidebarMenu", subItem.text)
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list-group>

    <!-- menu header -->
    <v-subheader v-else-if="item.header" :key="key">
      {{ item.header }}
    </v-subheader>

    <!--top-level link-->
    <v-list-item
      v-else
      :id="`AppDrawerChildMenuTopLevel${item.name}`"
      ref="listItem"
      :to="
        !item.href && typeof item.name !== 'undefined'
          ? { path: localePath(`/${item.name}`), query: item.query }
          : null
      "
      :href="item.href"
      :disabled="item.disabled"
      :target="item.target"
      nuxt
      ripple="ripple"
      active-class="blue-grey--text text--darken-3 blue-grey lighten-3"
      :class="{
        'blue-grey--text text--darken-3 blue-grey lighten-3':
          ($route !== null &&
            typeof $route !== 'undefined' &&
            $route.path !== null &&
            typeof $route.path !== 'undefined' &&
            $route.path.includes('/profile') &&
            item.text === 'Dashboard') ||
          isOpened,
      }"
      @click="item.action ? call(item.action) : null"
    >
      <v-list-item-action v-if="item.icon">
        <v-icon>
          {{ generateIcons(item.icon) }}
        </v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ $helpers.translateKeyContent("FalconSidebarMenu", item.text) }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <!-- dialog -->
    <customise-navigation ref="custNav" />
  </div>
</template>

<script>
import CustomiseNavigation from "@/components/shared/CustomiseNavigation";

import * as drawerIcons from "@/shared/constants/drawerIcons.constant";

export default {
  name: "AppDrawerChild",

  components: {
    CustomiseNavigation,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mini: false,
      key: this.$attrs.key,
      menuIcons: drawerIcons,
    };
  },

  computed: {},

  mounted() {
    // set opened child menu based on isOpened
    if (
      this.$refs.listGroup !== null &&
      typeof this.$refs.listGroup !== "undefined"
    ) {
      if (this.isOpened) {
        this.$refs.listGroup.isActive = true;
      }
    }

    // set active menu based on isOpened
    if (
      this.$refs.listItem !== null &&
      typeof this.$refs.listItem !== "undefined"
    ) {
      if (this.isOpened) {
        this.$refs.listItem.isActive = true;
      }
    }
  },

  methods: {
    generateLink(item, subItem) {
      if (subItem.href) return {};
      if (subItem.component) {
        return {
          name: subItem.component,
          query: subItem.query,
        };
      }

      return {
        path: this.localePath(`/${item.group}/${subItem.name}`),
        query: subItem.query,
      };
    },
    call(action) {
      this[action]();
    },
    // action (in menu.js)
    customiseNavigation() {
      // this.$store.dispatch('app/toggleModal', [
      //     'customiseNavigation'
      // ]);
      this.$refs.custNav.openModal();
    },
    generateIcons(iconName) {
      for (const icon in this.menuIcons) {
        if (iconName === icon) {
          return this.menuIcons[iconName];
        }
      }
      return iconName;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep#appDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }
}

::v-deep.v-list__group__items {
  a.v-list__tile {
    padding-left: 25px;
  }
}
</style>
